import { useMemo } from 'react';
import { useAuth } from './use-auth';
import { AdminRoles } from '@/lib/types';

export default function useIsInAdminGroup(): boolean {
  const { role } = useAuth();

  return useMemo(() => {
    if (!role) return false;

    const adminRoles = [AdminRoles.WorkspaceAdmin, AdminRoles.MasterAdmin];

    return adminRoles.includes(role.id);
  }, [role]);
}
